(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }
  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-konverso"] && !Shopify.designMode) return;
  try {
    
(function(){
  var idsRegistrados = [];
  var listenerGlobal = false;

  function feedbackBtn(btn, ok){
    var original = btn.getAttribute('data-label-original') || btn.textContent;
    btn.setAttribute('data-label-original', original);
    btn.textContent = ok ? 'Copiado' : 'Pulsa Ctrl/Cmd+C';
    setTimeout(function(){ btn.textContent = original; }, 1800);
  }

  function copiarId(btn){
    var wrap = btn.closest ? btn.closest('.draco-id-copy-wrap') : null;
    var input = wrap ? wrap.querySelector('[data-draco-id-input]') : null;
    if(!input) return;
    input.removeAttribute('readonly');
    input.focus();
    input.select();
    try{ input.setSelectionRange(0, input.value.length); }catch(e){}
    var copiado = false;
    try{ copiado = document.execCommand('copy'); }catch(e){ copiado = false; }
    input.setAttribute('readonly', 'readonly');
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(input.value).then(function(){
        feedbackBtn(btn, true);
      }).catch(function(){
        feedbackBtn(btn, copiado);
      });
    } else {
      feedbackBtn(btn, copiado);
    }
  }

  function registrarScroll(id){
    if(!id) return;
    if(idsRegistrados.indexOf(id) === -1){ idsRegistrados.push(id); }
    if(listenerGlobal) return;
    document.addEventListener('click', function(e){
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if(!a) return;
      var hash = a.hash || '';
      if(!hash) return;
      var objetivo = hash.slice(1);
      if(idsRegistrados.indexOf(objetivo) === -1) return;
      var destino = document.getElementById(objetivo);
      if(!destino) return;
      e.preventDefault();
      destino.scrollIntoView({behavior: 'smooth', block: 'start'});
      if(history.replaceState){ history.replaceState(null, '', hash); }
    });
    listenerGlobal = true;
  }

  function init(root){
    var cont = root.querySelector('.draco-resenas');

    registrarScroll(root.getAttribute('data-draco-id'));

    root.querySelectorAll('[data-draco-copiar]').forEach(function(btn){
      btn.addEventListener('click', function(){
        copiarId(btn);
      });
    });

    if(!cont) return;
    var wrap = root.querySelector('.draco-tarjeta');
    var cards = Array.prototype.slice.call(cont.querySelectorAll('.draco-card'));
    var btn = cont.querySelector('[data-draco-more]');
    var limM = parseInt(wrap.getAttribute('data-limite-movil'),10) || 4;
    var limD = parseInt(wrap.getAttribute('data-limite-escritorio'),10) || 6;
    var paso = parseInt(wrap.getAttribute('data-paso'),10) || 4;
    var limite = window.innerWidth >= 990 ? limD : limM;
    var visibles = limite;

    function render(){
      cards.forEach(function(c,i){
        if(i < visibles){ c.classList.remove('draco-card--oculta'); }
        else { c.classList.add('draco-card--oculta'); }
      });
      if(btn){ btn.style.display = visibles >= cards.length ? 'none' : 'inline-block'; }
    }
    render();

    if(btn){
      btn.addEventListener('click', function(){
        visibles += paso;
        render();
      });
    }

    root.querySelectorAll('[data-draco-scroll]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        cont.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });
  }
  document.querySelectorAll('.draco-wrap').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.draco-wrap');
    if(r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-barra-actividad"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializarTicker(seccionId){
    var seccion=document.querySelector('[data-kticker-id="'+seccionId+'"]');
    if(!seccion){ return; }
    var mensajes=seccion.querySelectorAll('.kticker-mensaje');
    if(!mensajes.length){ return; }
    var duracion=parseInt(seccion.getAttribute('data-kticker-duracion'),10);
    if(!duracion||isNaN(duracion)){ duracion=2500; }
    var pausarHover=seccion.getAttribute('data-kticker-pausar')==='true';
    var indiceActual=0;
    var intervalo=null;

    function mostrar(indice){
      indiceActual=indice;
      mensajes.forEach(function(el,i){
        if(i===indice){
          el.classList.add('kticker-activo');
        } else {
          el.classList.remove('kticker-activo');
        }
      });
    }
    function siguiente(){
      mostrar((indiceActual+1)%mensajes.length);
    }
    function iniciar(){
      if(intervalo||mensajes.length<2){ return; }
      intervalo=setInterval(function(){
        if(document.visibilityState==='visible'){
          siguiente();
        }
      },duracion);
    }
    function detener(){
      if(intervalo){
        clearInterval(intervalo);
        intervalo=null;
      }
    }

    mostrar(0);
    iniciar();

    if(pausarHover){
      seccion.addEventListener('mouseenter',detener);
      seccion.addEventListener('mouseleave',iniciar);
      seccion.addEventListener('focusin',detener);
      seccion.addEventListener('focusout',iniciar);
    }
    document.addEventListener('visibilitychange',function(){
      if(document.visibilityState==='visible'){
        iniciar();
      }
    });

    seccion.ktickerDetener=detener;
    seccion.ktickerIniciar=iniciar;
    seccion.ktickerMostrar=mostrar;
  }
  function destruirTicker(seccionId){
    var seccion=document.querySelector('[data-kticker-id="'+seccionId+'"]');
    if(seccion&&seccion.ktickerDetener){
      seccion.ktickerDetener();
    }
  }
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-kticker-id]').forEach(function(el){
      inicializarTicker(el.getAttribute('data-kticker-id'));
    });
  });
  document.addEventListener('shopify:section:load',function(evento){
    inicializarTicker(evento.detail.sectionId);
  });
  document.addEventListener('shopify:section:unload',function(evento){
    destruirTicker(evento.detail.sectionId);
  });
  document.addEventListener('shopify:block:select',function(evento){
    var mensaje=evento.target.closest('.kticker-mensaje');
    if(!mensaje){ return; }
    var seccion=mensaje.closest('.kticker-seccion');
    if(!seccion||!seccion.ktickerMostrar){ return; }
    var lista=Array.prototype.slice.call(seccion.querySelectorAll('.kticker-mensaje'));
    var indice=lista.indexOf(mensaje);
    if(indice>-1){
      seccion.ktickerDetener();
      seccion.ktickerMostrar(indice);
    }
  });
  document.addEventListener('shopify:block:deselect',function(evento){
    var mensaje=evento.target.closest('.kticker-mensaje');
    if(!mensaje){ return; }
    var seccion=mensaje.closest('.kticker-seccion');
    if(seccion&&seccion.ktickerIniciar){
      seccion.ktickerIniciar();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-carrusel-productos"] && !Shopify.designMode) return;
  try {
    
(function(){
  function mostrarError(tarjeta, mensaje){
    var errorEl = tarjeta.querySelector('[data-kprod-error]');
    if(!errorEl){ return; }
    errorEl.textContent = mensaje;
    window.setTimeout(function(){
      errorEl.textContent = '';
    }, 4000);
  }

  function abrirCartDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer){ return; }
    if(typeof drawer.open === 'function'){
      drawer.open();
    } else {
      drawer.classList.add('active');
      drawer.dispatchEvent(new CustomEvent('open', { bubbles:true }));
    }
  }

  function actualizarCartDrawer(data, seccionId){
    if(!data.sections || !seccionId || !data.sections[seccionId]){ return; }
    var html = data.sections[seccionId];
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('cart-drawer');
    var actual = document.querySelector('cart-drawer');
    if(nuevo && actual){
      actual.innerHTML = nuevo.innerHTML;
      actual.classList.remove('is-empty');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true, detail:{ cart:data } }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles:true, detail:{ cart:data } }));
  }

  function agregarAlCarrito(boton){
    if(boton.disabled){ return; }
    var variantId = boton.getAttribute('data-variant-id');
    if(!variantId){ return; }
    var tarjeta = boton.closest('.kprod-tarjeta');
    var seccion = boton.closest('[data-kprod-seccion]');
    var seccionCartDrawer = seccion ? seccion.getAttribute('data-cart-drawer-section') : '';
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    boton.disabled = true;
    boton.classList.add('kprod-cargando');
    fetch(raiz.replace(/\/$/, '') + '/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({
        items:[{ id: variantId, quantity: 1 }],
        sections: seccionCartDrawer,
        sections_url: window.location.pathname
      })
    })
      .then(function(respuesta){
        return respuesta.json().then(function(datos){
          return { ok: respuesta.ok, datos: datos };
        });
      })
      .then(function(resultado){
        if(!resultado.ok){
          mostrarError(tarjeta, resultado.datos.description || 'No se pudo anadir al carrito');
          return;
        }
        actualizarCartDrawer(resultado.datos, seccionCartDrawer);
        abrirCartDrawer();
      })
      .catch(function(){
        mostrarError(tarjeta, 'No se pudo anadir al carrito');
      })
      .finally(function(){
        boton.disabled = false;
        boton.classList.remove('kprod-cargando');
      });
  }

  function actualizarThumb(seccion){
    var carrusel = seccion.querySelector('[data-kprod-carrusel]');
    var thumb = seccion.querySelector('[data-kprod-scrollbar-thumb]');
    if(!carrusel || !thumb){ return; }
    var track = thumb.parentElement;
    var trackWidth = track.clientWidth;
    var maxScroll = carrusel.scrollWidth - carrusel.clientWidth;
    var ratioVisible = carrusel.scrollWidth > 0 ? Math.min(carrusel.clientWidth / carrusel.scrollWidth, 1) : 1;
    var thumbWidth = Math.max(trackWidth * ratioVisible, 30);
    var thumbLeft = maxScroll > 0 ? (carrusel.scrollLeft / maxScroll) * (trackWidth - thumbWidth) : 0;
    thumb.style.width = thumbWidth + 'px';
    thumb.style.left = thumbLeft + 'px';
  }

  function inicializarSeccion(seccionId){
    var seccion = document.getElementById('kprod-' + seccionId);
    if(!seccion){ return; }
    var carrusel = seccion.querySelector('[data-kprod-carrusel]');
    if(!carrusel){ return; }
    var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    actualizarThumb(seccion);
    carrusel.addEventListener('scroll', function(){
      window.requestAnimationFrame(function(){
        actualizarThumb(seccion);
      });
    }, { passive:true });

    window.addEventListener('resize', function(){
      actualizarThumb(seccion);
    });

    seccion.querySelectorAll('[data-kprod-flecha]').forEach(function(flecha){
      flecha.addEventListener('click', function(){
        var direccion = flecha.getAttribute('data-kprod-flecha') === 'izq' ? -1 : 1;
        var delta = carrusel.clientWidth * 0.85 * direccion;
        carrusel.scrollBy({ left: delta, behavior: reducirMovimiento ? 'auto' : 'smooth' });
      });
    });

    seccion.querySelectorAll('[data-kprod-boton-carrito]').forEach(function(boton){
      boton.addEventListener('click', function(){
        agregarAlCarrito(boton);
      });
    });

    seccion.querySelectorAll('[data-kprod-favorito]').forEach(function(boton){
      boton.addEventListener('click', function(){
        var activo = boton.getAttribute('aria-pressed') === 'true';
        boton.setAttribute('aria-pressed', activo ? 'false' : 'true');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-kprod-seccion]').forEach(function(el){
      var id = el.id.replace('kprod-', '');
      inicializarSeccion(id);
    });
  });
  document.addEventListener('shopify:section:load', function(evento){
    inicializarSeccion(evento.detail.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function inicializarFaq(seccionId){
    var seccion = document.getElementById('kfaq-' + seccionId);
    if(!seccion){ return; }
    var items = seccion.querySelectorAll('[data-kfaq-item]');
    if(!items.length){ return; }
    var soloUna = seccion.getAttribute('data-kfaq-solo-una') === 'true';
    items.forEach(function(item){
      var boton = item.querySelector('[data-kfaq-boton]');
      if(!boton || boton.dataset.kfaqListo === 'true'){ return; }
      boton.dataset.kfaqListo = 'true';
      boton.addEventListener('click', function(){
        var estabaAbierto = item.classList.contains('kfaq-abierto');
        if(soloUna && !estabaAbierto){
          items.forEach(function(otro){
            if(otro !== item && otro.classList.contains('kfaq-abierto')){
              otro.classList.remove('kfaq-abierto');
              var otroBoton = otro.querySelector('[data-kfaq-boton]');
              if(otroBoton){
                otroBoton.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }
        item.classList.toggle('kfaq-abierto', !estabaAbierto);
        boton.setAttribute('aria-expanded', !estabaAbierto ? 'true' : 'false');
      });
    });
  }
  function inicializarTodas(){
    document.querySelectorAll('.kfaq-seccion').forEach(function(el){
      inicializarFaq(el.id.replace('kfaq-', ''));
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', inicializarTodas);
  } else {
    inicializarTodas();
  }
  document.addEventListener('shopify:section:load', function(evento){
    inicializarFaq(evento.detail.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-hero-principal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function formatearNumero(valor,decimales){
    return valor.toLocaleString('es-MX',{minimumFractionDigits:decimales,maximumFractionDigits:decimales});
  }
  function easeOutQuad(t){
    return t*(2-t);
  }
  function animarValor(el,valorFinal,decimales,duracion,sufijo){
    var reducirMovimiento=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reducirMovimiento){
      el.textContent=formatearNumero(valorFinal,decimales)+sufijo;
      return;
    }
    var inicio=null;
    function paso(marca){
      if(inicio===null){ inicio=marca; }
      var progreso=Math.min((marca-inicio)/duracion,1);
      var valorActual=valorFinal*easeOutQuad(progreso);
      if(decimales>0){
        var factor=Math.pow(10,decimales);
        valorActual=Math.round(valorActual*factor)/factor;
      } else {
        valorActual=Math.round(valorActual);
      }
      el.textContent=formatearNumero(valorActual,decimales)+sufijo;
      if(progreso<1){
        window.requestAnimationFrame(paso);
      } else {
        el.textContent=formatearNumero(valorFinal,decimales)+sufijo;
      }
    }
    window.requestAnimationFrame(paso);
  }
  function inicializarSeccion(seccionId){
    var seccion=document.querySelector('[data-khero-id="'+seccionId+'"]');
    if(!seccion){ return; }
    var animarActivado=seccion.getAttribute('data-khero-animar')==='true';
    var duracion=parseInt(seccion.getAttribute('data-khero-duracion'),10);
    if(!duracion||isNaN(duracion)){ duracion=2000; }
    var numeros=seccion.querySelectorAll('.khero-feature-numero-valor');
    if(!numeros.length){ return; }
    if(!animarActivado||typeof window.IntersectionObserver==='undefined'){
      numeros.forEach(function(el){
        var valorFinal=parseFloat(el.getAttribute('data-valor-final'));
        var decimales=parseInt(el.getAttribute('data-decimales'),10)||0;
        var sufijo=el.getAttribute('data-sufijo')||'';
        if(!isNaN(valorFinal)){
          el.textContent=formatearNumero(valorFinal,decimales)+sufijo;
        }
      });
      return;
    }
    var animados=new WeakSet();
    var observador=new IntersectionObserver(function(entradas){
      entradas.forEach(function(entrada){
        if(entrada.isIntersecting&&!animados.has(entrada.target)){
          animados.add(entrada.target);
          var el=entrada.target;
          var valorFinal=parseFloat(el.getAttribute('data-valor-final'));
          var decimales=parseInt(el.getAttribute('data-decimales'),10)||0;
          var sufijo=el.getAttribute('data-sufijo')||'';
          if(!isNaN(valorFinal)){
            animarValor(el,valorFinal,decimales,duracion,sufijo);
          }
          observador.unobserve(el);
        }
      });
    },{threshold:0.4});
    numeros.forEach(function(el){
      observador.observe(el);
    });
    seccion.kheroObservador=observador;
  }
  function destruirSeccion(seccionId){
    var seccion=document.querySelector('[data-khero-id="'+seccionId+'"]');
    if(seccion&&seccion.kheroObservador){
      seccion.kheroObservador.disconnect();
      seccion.kheroObservador=null;
    }
  }
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-khero-id]').forEach(function(el){
      inicializarSeccion(el.getAttribute('data-khero-id'));
    });
  });
  document.addEventListener('shopify:section:load',function(evento){
    inicializarSeccion(evento.detail.sectionId);
  });
  document.addEventListener('shopify:section:unload',function(evento){
    destruirSeccion(evento.detail.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-productos-recomendados"] && !Shopify.designMode) return;
  try {
    
(function(){
  function cargarRecomendaciones(seccion){
    if(!seccion || seccion.dataset.krecoListo === 'true'){ return; }
    var url = seccion.getAttribute('data-url');
    if(!url || url.indexOf('product_id=&') !== -1){ return; }
    var lista = seccion.querySelector('[data-kreco-lista]');
    if(!lista){ return; }
    seccion.dataset.krecoListo = 'true';
    if(lista.children.length > 0){
      seccion.classList.remove('kreco-cargando');
      return;
    }
    fetch(url)
      .then(function(respuesta){ return respuesta.text(); })
      .then(function(texto){
        var documento = new DOMParser().parseFromString(texto, 'text/html');
        var nueva = documento.querySelector('[data-kreco-lista]');
        if(nueva && nueva.innerHTML.trim() !== ''){
          lista.innerHTML = nueva.innerHTML;
          seccion.classList.remove('kreco-sin-productos');
          seccion.classList.remove('kreco-cargando');
        } else {
          seccion.classList.add('kreco-sin-productos');
        }
      })
      .catch(function(){
        seccion.classList.add('kreco-sin-productos');
      });
  }
  function iniciarTodas(){
    document.querySelectorAll('[data-kreco]').forEach(cargarRecomendaciones);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }
  document.addEventListener('shopify:section:load', function(evento){
    var seccion = document.getElementById('kreco-' + evento.detail.sectionId);
    if(seccion){
      seccion.dataset.krecoListo = 'false';
      cargarRecomendaciones(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
